/* eslint-disable no-undef */
import ObjectStorage from "../modules/ObjectStorage";
import get from "lodash/get";
import Navigation from "./NavigationService";
import History from "../components/NavigateSetter/History";
import { StorageConstants } from "../constants/AppConstants";
import { DASHBOARD_PATHS } from "../routes/paths";

//------------------------------------------------------------------------------------------

const AuthService = {
  _getAccessToken() {
    return get(ObjectStorage.getItem(StorageConstants.ACCESS_TOKEN), "token");
  },
  _getRefreshToken() {
    return get(ObjectStorage.getItem("refreshToken"), "token");
  },
  logout() {
    ObjectStorage.removeItem(StorageConstants.ACCESS_TOKEN);
    ObjectStorage.removeItem(StorageConstants.REFRESH_TOKEN);
    ObjectStorage.removeItem(StorageConstants.CUSTOMER_INFORMATION);
    ObjectStorage.removeItem(StorageConstants.MERCHANT_DETAILS);
    ObjectStorage.removeItem(StorageConstants.BILLING_KEY_STATUS);
    Navigation.navigateToLogin();
  },
  forceLogout() {
    this.logout();
    History.navigate?.(DASHBOARD_PATHS.LANDING, { replace: true });
  },
  _getMerchantDetails() {
    return ObjectStorage.getItem(StorageConstants.MERCHANT_DETAILS, "data");
  },
  goto404() {
    window.location.href = "*";
  },
  _getMerchantId() {
    return get(
      ObjectStorage.getItem(StorageConstants.MERCHANT_DETAILS),
      "data.merchantId"
    );
  },
  getDeviceId() {
    return get(ObjectStorage.getItem(StorageConstants.DEVICE_UNIQUE_ID), "id");
  },
  getBillingKeyStatus() {
    return get(
      ObjectStorage.getItem(StorageConstants.BILLING_KEY_STATUS),
      "value",
      false
    );
  },
  getBillingKey() {
    return get(
      ObjectStorage.getItem(StorageConstants.BILLING_KEY_STATUS),
      "key"
    );
  },
  getRemoteURL() {
    return import.meta.env.VITE_REMOTE_URL;
  },
  getShopName() {
    return get(
      ObjectStorage.getItem(StorageConstants.MERCHANT_DETAILS),
      "data.storeName",
      process.env.REACT_APP_SHOP_NAME
    );
  },
  getAddress() {
    return get(
      ObjectStorage.getItem(StorageConstants.MERCHANT_DETAILS),
      "data.address",
      process.env.REACT_APP_SHOP_ADDRESS
    );
  },
  getStoreId() {
    return get(
      ObjectStorage.getItem(StorageConstants.MERCHANT_DETAILS),
      "data.storeId"
    );
  },
  getTerminalId() {
    return get(
      ObjectStorage.getItem(StorageConstants.MERCHANT_DETAILS),
      "data.terminalId"
    );
  },
};

export default AuthService;
